import { createTypes } from 'redux-compose-reducer';
import { get } from 'utils/apiRequester';
import { authError } from './auth';
import { conversationPageType } from 'pages/conversations/ConversationsPage';


export const TYPES = createTypes('coversations', [
  'getConversations',
  'clearConversations'
]);


export function getConversations(dispatch, history, pagination, filter) {
  const { current, pageSize } = pagination;
  const offset = current * pageSize;
  let url = `/api/chat/internal/conversation/${ offset }/${ pageSize }?filter=${ filter }`;

  if (filter === conversationPageType.unanswered24h) {
    url = `/api/chat/internal/conversation/unanswered24/${ offset }/${ pageSize }`;
  }

  return get(url)
    .then(({ data }) => {
      return dispatch({
        type: TYPES.getConversations,
        data,
        pagination
      });
    })
    .catch(err => authError(dispatch, err, history, true, false));
}


export function clearConversations(dispatch) {
  return dispatch({
    type: TYPES.clearConversations
  });
}




// WEBPACK FOOTER //
// ./src/actions/conversations.js